import { withStyles } from '@material-ui/styles';
import { Link } from 'react-router-dom';
import React, { useState, useEffect, useContext } from 'react';
import logo from '../../assets/images/bluesky-vue-logo.png';
import classnames from 'classnames';
import LinearProgress from '@material-ui/core/LinearProgress';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import Checkbox from '@material-ui/core/Checkbox';
import { updateInVisionIQPhoneNumber, getSelfInspect } from '../../services';
import { AppContext } from '../../AppContext';
import queryString from 'query-string';

var { version: appVersion } = require('../../../package.json');
const styles = theme => ({});

const SelfInspectEdit = withStyles(styles)(props => {
  const [formData, setFormData] = useState({
    phoneNumber: '',
    insuredName: 'default',
  });
  const { classes, match } = props;
  const [updateLoading, setUpdateLoading] = useState(false);
  const [updateError, setUpdateError] = useState('');
  const [updateSuccess, setUpdateSuccess] = useState(false);
  const [selfInspectIntro, setSelfInspectIntro] = useState({});
  const [isSaving, setIsSaving] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [failedToLoad, setFailedToLoad] = useState(false);
  const [query] = useState(queryString.parse(props.history.location.search));

  const { state, dispatch } = useContext(AppContext);

  const attemptUpdate = async evt => {
    evt.preventDefault();
    setUpdateError('');
    setUpdateSuccess(false);
    setUpdateLoading(true);

    if (!formData.phoneNumber) {
      setUpdateError('Phone number is required');
      setUpdateLoading(false);
      return;
    }

    if (!match.params.orderKey) {
      setUpdateError('Order not found');
      setUpdateLoading(false);
      return;
    }

    try {
      const inspectorData = await updateInVisionIQPhoneNumber(match.params.orderKey, formData.phoneNumber);
      setUpdateSuccess(true);
      setUpdateLoading(false);
    } catch (error) {
      console.log(error);
      setUpdateLoading(false);
      setUpdateError(error.error);
      setUpdateSuccess(false);
    }
  };

  const updateField = field => event => {
    setFormData({
      ...formData,
      [field]: event.target.value,
    });
  };

  const checkOrder = () => {
    /**
     * 1. get order guid from url
     * 2. answer auth questions
     * 3. get auth token
     */
  };

  useEffect(() => {
    const setupSelfInspect = async () => {
      try {
        // const data = await getDashboardCounts('ADMIN');
        // setStatusCards(data.sort((a, b) => (a.seq > b.seq ? 1 : -1)));
        const landingPageInfo = await getSelfInspect(match.params.orderKey);
        setIsLoading(false);
        setSelfInspectIntro(landingPageInfo);
        console.log(selfInspectIntro);
        console.log(landingPageInfo);
      } catch (error) {
        setIsLoading(false);
        setFailedToLoad(true);
        setSelfInspectIntro([]);
      }
    };

    //checkOrder();
    setupSelfInspect();

  }, []);

  return (
    <div className={classnames('app', 'login-background', 'col-center-center')}>
      <div
        className={classnames('login-card')}
        style={{
          margin: '30px auto',
        }}
      >
        <div className={classnames('login-card-left', 'col-center-center')}>
          <img src={logo} alt={'BlueSky Vue Logo'} style={{ maxWidth: '100%', height: 'auto' }} />
        </div>
        <div className={classnames('login-card-right', 'col-center-center')}>
          <form id="login-form" style={{ width: '90%' }} onSubmit={attemptUpdate}>
            <div
              style={{
                fontSize: 28,
              }}
              className="mb-10 blue-text text-bold"
            >
              InVisionIQ
            </div>

            <Typography variant="body2" className="text-hint" style={{ marginBottom: 15 }}>
              Please enter a valid mobile number for {selfInspectIntro.insuredName ?? 'the insured'} that an InVisionIQ survey link can be sent to.
            </Typography>

            <div className="col-start-start">
              <label>Mobile phone</label>
              <TextField
                value={formData.phoneNumber}
                margin="dense"
                variant="outlined"
                inputProps={{ 'aria-label': 'bare' }}
                style={{ width: '100%' }}
                onChange={updateField('phoneNumber')}
                disabled={updateSuccess}
              />
            </div>

            <div style={{ marginTop: 20 }} className={classnames('row-center-center', 'full-width')}>
              <button type="submit" className="login-submit-button" hidden={updateSuccess}>
                Submit
              </button>
            </div>
          </form>

          <div className="login-card-submit-details">
            {updateError && <div className="login-card-error">{updateError}</div>}
            {updateSuccess && <div style={{color: "#17c80d"}}>Phone number updated successfully!</div>}
            {updateLoading && <LinearProgress className="login-card-loading" />}
          </div>
        </div>
      </div>
      <div style={{ margin: '25px auto', color: '#aaa', fontSize: 14 }}>Version {appVersion}</div>
    </div>
  );
});

SelfInspectEdit.propTypes = {};

export default SelfInspectEdit;
